import { render, staticRenderFns } from "./ChangeSubmenu.vue?vue&type=template&id=41f21763"
import script from "./ChangeSubmenu.vue?vue&type=script&lang=js"
export * from "./ChangeSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports